import { Entity } from "@hds/entity-lib";

class EventEngineStateEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        eventTypeBiddingRules: {},
        runList: [],
        authCargo: {}
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...EventEngineStateEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get eventType() {
        return this._virtualDataModel.getProperty('eventType');
    }
    set eventType(newEventType) {
        return this._virtualDataModel.setProperty('eventType', newEventType);
    }
    get eventTypeBiddingRules() {
        return this._virtualDataModel.getProperty('eventTypeBiddingRules');
    }
    set eventTypeBiddingRules(newEventTypeBiddingRules) {
        return this._virtualDataModel.setProperty('eventTypeBiddingRules', newEventTypeBiddingRules);
    }
    get runList() {
        return this._virtualDataModel.getProperty('runList');
    }
    set runList(newRunList) {
        return this._virtualDataModel.setProperty('runList', newRunList);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}
//META PROPERTIES
Object.defineProperty(EventEngineStateEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'event-engine-state'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { EventEngineStateEntity };
export default EventEngineStateEntity;